import classNames from 'classnames'
import React from 'react'
import { connect } from 'react-redux'

import { State } from 'admin/redux/ducks'
import { CrossIcon } from 'components/ui/Icons'
import { showModalAction, hideModalAction, ModalState } from 'redux/ducks/modal'

/**
 * Main modal component
 */
export class Modal extends React.Component<ModalProps, any> {
  constructor(props) {
    super(props)
  }

  render() {
    const { modal } = this.props
    const {
      visible,
      closable,
      scrolling,
      maxWidth,
      minWidth,
      scrollinghorizontal,
      component,
    } = modal || {
          visible: null,
          closable: null,
          scrolling: null,
          maxWidth: null,
          minWidth: null,
          scrollinghorizontal: null,
          component: null,
        }
    const modalClasses = classNames(
      'Modal',
      scrolling && 'Modal--scrolling',
      scrollinghorizontal && 'Modal--scrolling__h',
      maxWidth && `Modal--max-width__${  maxWidth}`,
      minWidth && `Modal--min-width__${  minWidth}`,
    )
    if (visible) {
      return (
        <div
          className="Modal__overlay"
          onClick={closable ? this.props.hideModal : null}
        >
          <div className={modalClasses} onClick={e => e.stopPropagation()}>
            {React.cloneElement(
              component as React.ReactElement<any>,
              this.props,
            )}
          </div>
        </div>
      )
    } 
      return null
    
  }
}
type ModalProps = {
  modal: ModalState
  showModal: (component: React.ReactNode) => void
  hideModal: () => void
}
const mapStateToProps = (state: State, ownProps) => {
  return {
    modal: state.modal as ModalState,
  }
}
const mapDispatchToProps = dispatch => {
  return {
    showModal: (component: React.ReactNode) =>
      dispatch(showModalAction(component)),
    hideModal: () => dispatch(hideModalAction()),
  }
}
export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Modal)

/**
 * Modal container wrapping header, content and footer
 */
export const ModalContainer: React.FunctionComponent<any> = props => {
  return <div className="Modal__container">{props.children}</div>
}

const ModalHeaderComponent: React.FunctionComponent<
  ModalHeaderProps & ModalProps
> = props => {
  return (
    <div className="Modal__header l-columns l-flex--all-sizes">
      <div className="Modal__header__text l-flex">{props.text}</div>
      {props.modal.closable && (
        <button
          className="Modal__header__close-button button--flat button--icon l-flex l-flex--fixed"
          onClick={props.hideModal}
        >
          <CrossIcon />
        </button>
      )}
    </div>
  )
}
type ModalHeaderProps = {
  text: React.ReactNode
}
export const ModalHeader = connect(
  mapStateToProps,
  mapDispatchToProps,
)(ModalHeaderComponent)

export const ModalBody: React.FunctionComponent<ModalBodyProps> = props => {
  return <div className="Modal__body">{props.children}</div>
}
type ModalBodyProps = {
  children: React.ReactNode
}

export const ModalFooter: React.FunctionComponent<
  ModalFooterProps
> = props => {
  return <div className="Modal__footer">{props.children}</div>
}
type ModalFooterProps = {
  children: React.ReactNode
}
